import styled from 'styled-components';
import { Row, Col, Button, Checkbox } from 'antd';
import { Title as AntdTitle } from '@/components/Typography';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

interface CustomButtonProps {
	$isSelected: boolean;
}

export const Container = styled(Row)`
	padding: 30px;
	border-radius: 0 0 16px 16px;
	background-color: #ffffff;
`;

export const Header = styled(Row)`
	width: 100%;
	display: flex;
	overflow-x: auto;
	flex-wrap: nowrap;
	padding-bottom: 10px;
	::-webkit-scrollbar-track {
		border: none;
		padding: 0 2px;
		background-color: transparent;
	}
	::-webkit-scrollbar {
		width: 85%;
		height: 5px;
	}
	::-webkit-scrollbar-thumb {
		border-radius: 0.5rem;
		background-color: transparent;
		box-shadow: inset 0 0 6px #9c9c9c;
	}
`;

export const CustomButton = styled(Button)<CustomButtonProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 9px;
	padding: 22px 45px;
	font-size: 1rem;
	font-weight: 600;
	color: ${({ $isSelected }) => ($isSelected ? '#FFFFFF' : '#262626')};
	background-color: ${({ $isSelected }) => ($isSelected ? DEFAULT_RISK_RPN_COLOR : '#FFFFFF')};
	border: 2px solid ${({ $isSelected }) => ($isSelected ? DEFAULT_RISK_RPN_COLOR : ' #e6e6e6')};
	&:focus {
		background-color: ${DEFAULT_RISK_RPN_COLOR};
		color: ${({ $isSelected }) => ($isSelected ? '#FFFFFF' : DEFAULT_RISK_RPN_COLOR)};
	}
	&:hover {
		color: ${({ $isSelected }) => ($isSelected ? '#FFFFFF' : DEFAULT_RISK_RPN_COLOR)};
		background-color: ${({ $isSelected }) => ($isSelected ? DEFAULT_RISK_RPN_COLOR : '#FFFFFF')};
	}
`;

export const SubContainer = styled(Checkbox)`
	width: 100%;
	padding: 3%;
	font-size: 1rem;
	border-radius: 12px;
	border: 2px solid ${({ checked }) => (checked ? '#FFFFFF' : '#D9D9D9')};
	background-color: ${({ checked }) => (checked ? '#eaeefd' : '#FFFFFF')};
	span {
		width: 100%;
	}
	.ant-checkbox {
		display: none;
	}
	.score {
		color: #ffffff;
		font-size: 1rem;
		padding: 2px 4px;
		border-radius: 6px;
		background-color: ${({ checked }) => (checked ? DEFAULT_RISK_RPN_COLOR : '#b3b3b3')};
	}
`;

export const Label = styled(Col)`
	display: flex;
	justify-content: flex-end;
`;

export const StyledTitle = styled(AntdTitle)`
	position: relative;
	margin-right: 20px;
	margin-top: 10px;
	text-align: right;
	white-space: nowrap;
`;

export const TooltipContainer = styled.div`
	position: absolute;
	top: 5px;
	right: 7px;
`;
